// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteBrand, getAllBrands, getBrand, updateBrand } from '../../helpers/backend_helper';
import { fetchBrandsFailure, fetchBrandsSuccess, updateBrandFailure, updateBrandSuccess } from './actions';
import { deleteBrandFailure, deleteBrandSuccess, fetchBrandFailure, fetchBrandSuccess } from '../actions';
import { DELETE_BRANDS_REQUEST, FETCH_BRANDS_REQUEST, FETCH_BRAND_REQUEST, UPDATE_BRANDS_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchBrandsSaga() {
  try {
    const response = yield call(getAllBrands);

    yield put(fetchBrandsSuccess(response.data));
  } catch (error) {
    yield put(fetchBrandsFailure(reduxSerializedError(error)));
  }
}

function* fetchBrandSaga({ payload }) {
  try {
    const response = yield call(getBrand, payload);
    yield put(fetchBrandSuccess(response));
  } catch (error) {
    yield put(fetchBrandFailure(reduxSerializedError(error)));
  }
}

function* deleteBrandsSaga({ payload }) {
  try {
    yield call(deleteBrand, payload);
    yield put(deleteBrandSuccess(payload));
    yield call(fetchBrandsSaga);
  } catch (error) {
    yield put(deleteBrandFailure(reduxSerializedError(error)));
  }
}

function* updateBrandSaga({ payload }) {
  const { project } = payload;
  try {
    yield call(updateBrand, project);
    yield put(updateBrandSuccess());
    yield call(fetchBrandsSaga); 
  } catch (error) {
    yield put(updateBrandFailure(reduxSerializedError(error)));
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_BRANDS_REQUEST, fetchBrandsSaga);
  yield takeEvery(FETCH_BRAND_REQUEST, fetchBrandSaga);
  yield takeEvery(UPDATE_BRANDS_REQUEST, updateBrandSaga);
  yield takeEvery(DELETE_BRANDS_REQUEST, deleteBrandsSaga);
}
